import React from "react";

import Weather from "./pages/weather";

function App() {
	return (
		<div>
			<Weather />
		</div>
	);
}

export default App;
